import React, { useState, useEffect } from "react";
import { Button } from "react-materialize";
import $ from "jquery";
import config from "../../config";
import API from "../../utils/API";
import Func from "../../utils/Func";
import Handle from "../Container/modal.handle";
import ModalDone from "../Container/modal.done";
import ModalError from "../Container/modal.error";
import ModalWarning from "../Container/modal.warning";

export default function BtnSubmit({ events, header, action }) {
  const [resData, setResData] = useState({ status: "", err: 0, err_msg: "" });
  const callbackEvent = {
    OnClose: function () {
      setResData({ status: "", err: 0, err_msg: "" });
    },
    OnComplete: function () {
      events.OnComplete();
    } };
  const handleEvents = {
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setResData({ status: "", err: 0, err_msg: "" });
    },
    BtnCancel: {
      OnClick: function (evt) {
        evt.preventDefault();
        handleEvents.FormSubmit("RJ");
      } },
    BtnApprove: {
      OnClick: function (evt) {
        evt.preventDefault();
        handleEvents.FormSubmit("AP");
      } },
    FormSubmit: function (status_code) {
      Handle.loading.OnShow();
      const formData = Func.GetDataForm(
        $("#form-team-request-update").serializeArray(),
        "noarray"
      );
      formData["status_code"] = status_code;
      //console.log(formData);
      Handle.loading.OnShow();
      const mainFunc = async () =>
        await API.post("team/request/edit/submit", {
          params: ({
            userID: window.$user_profile.idu,
            formData: formData }) });
      mainFunc()
        .then((res) => {
          Handle.loading.OnHide();
          const decrypt = (res?.data);
          // console.log("response=", decrypt);
          if (decrypt?.status === "success") {
            setResData(decrypt);
          } else {
            setResData({
              err: 1,
              err_msg: `Failes : ` + decrypt?.err_msg ?? "" });
          }
        })
        .catch((err) => {
          Handle.loading.OnHide();
          setResData({ err: 1, err_msg: "" });
        });
    } };
  //console.log("Create Submit", resData);
  if (resData?.err === 1) {
    return (
      <ModalWarning
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if (resData?.err === 2) {
    return (
      <ModalError
        header={header}
        content={resData.err_msg}
        callbackEvent={callbackEvent}
      />
    );
  } else if (resData?.status === "success") {
    return (
      <ModalDone
        header={header}
        content="The update is done!"
        callbackEvent={callbackEvent}
      />
    );
  }
  let content = [];
  if (action === "reject" || action === "") {
    content.push(
      <Button
        key="btn-cancel"
        node="button"
        type="button"
        className="grey lighten-3"
        id="btn-cancel"
        onClick={handleEvents.BtnCancel.OnClick}
      >
        Reject
      </Button>
    );
  }
  if (action === "approve" || action === "") {
    content.push(
      <Button
        key="btn-approve"
        node="button"
        className=""
        id="btn-approve"
        onClick={handleEvents.BtnApprove.OnClick}
      >
        Approve
      </Button>
    );
  }
  return (
    <div key="content-right-btn" className="col s12" id="content-right-btn">
      {content}
    </div>
  );
}


